module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0057.jpg?v=3c592611";